import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de Dropbox (Dropbox International, Irlanda) -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas contra el texto pdfjs real (2 facturas). Obligatorios (throw): folio, fecha, monto.
// Suscripcion plana (Dropbox Plus) -> unidades null; concepto null (el hook arma "Dropbox AAAA/MM").
// Layout: "...Chile 9 de mayo de 2026 9:10 GMT KJWT5P659WZC Producto IMPORTE ... Subtotal 10,08 US$
//         + IVA (19 %) 1,91 US$ Total 11,99 US$ ..." (montos en USD, coma decimal).
export const parsearDropboxDesdeTexto = (texto) => {
  // folio: el ID de FACTURA alfanumerico entre "GMT" y "Producto" (ej. "KJWT5P659WZC"). Obligatorio.
  const mFolio = texto.match(/GMT\s+([\dA-Z]{8,})\s+Producto/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura Dropbox (falta ID de FACTURA)");
  const folio = mFolio[1];

  // fecha: "9 de mayo de 2026" (espanol largo; corta antes del " 9:10 GMT"). Obligatorio.
  // NO agarra el footer "5/7/26" ni el periodo de servicio "9/5/2026 a 9/6/2026" (el ancla exige "de").
  const mFecha = texto.match(/(\d{1,2} de [a-záéíñóú]+ de \d{4})/i);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;
  if (!fecha) throw new Error("No se pudo leer la fecha de la factura Dropbox");

  // monto: "Total 11,99 US$" -> 11.99 (Total con IVA incluido = lo que se paga). Obligatorio.
  // El \b evita capturar "Subtotal". Coma decimal + punto de miles -> normalizar a punto.
  const mMonto = texto.match(/\bTotal\s+([\d.]*\d,\d{2})\s*US\$/);
  if (!mMonto) throw new Error("No se pudo leer el Total de la factura Dropbox");
  const monto = Number(mMonto[1].replace(/\./g, "").replace(",", "."));

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto: null, monto, moneda: "USD", unidades: null };
};
